export const layersLoading = (state = {}, action) => {
  switch (action.type) {
    case 'START_LOADING_LAYER': {
      if (state[action.payload]) return state;
      return {
        ...state,
        [action.payload]: true,
      };
    }
    case 'STOP_LOADING_LAYER': {
      if (!state[action.payload]) return state;

      const newState = { ...state };
      if (newState[action.payload]) delete newState[action.payload];
      return newState;
    }
    case 'CLEAR_LOADING_LAYERS': {
      return {};
    }
    default:
      return state;
  }
};
